import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setCommunicationManagementPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useCommunicationManagementSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getCommunicationManagementSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.communication_management_page?.communication_management_section}`);
      console.log("🚀 ~ getCommunicationManagementSectionJson ~ data:", response);
      console.log("🚀 ~ getCommunicationManagementSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setCommunicationManagementPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Communication Management section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getCommunicationManagementSectionJson();
  }, [getCommunicationManagementSectionJson]);

  return {
    data,
    loading,
    error,
    getCommunicationManagementSectionJson,
    fetchOnMount,
    refetch: getCommunicationManagementSectionJson
  };
};

export default useCommunicationManagementSection;
